<!-- 新增代理协议 -->
<template>
  <div id="agencySelector">
    <a-row style="background: #F2F4F6;">
      <div>
        <!-- 继续添加 -->
        <a-button size="small" @click="openAddAgencyModal"><pt-icon type="icon-zengjia"></pt-icon>{{$t('dealConfirm.addNewAgency')}}</a-button>
        <span v-if="agencyList.length > 0" style="font-size: 12px;color: #999999;">{{$t('commission.agencyWarnInfo')}}</span>
        <pt-closeTag @hideButton="hideAgency"></pt-closeTag>
      </div>
      <div class="select_list">
        <a-form :form="dealConfirmForm">
          <a-form-item style="margin: 0;">
            <a-radio-group style="width: 100%;" v-decorator="decorators.agencyId" :disabled="disabled">
              <a-row>
                <a-col :span="8">{{$t('dealConfirm.agreementName')}}</a-col>
                <a-col :span="8">{{$t('dealConfirm.mansionName')}}</a-col>
                <a-col :span="8">{{$t('dealConfirm.agencyPeriod')}}</a-col>
              </a-row>
              <a-divider style="margin:0;"></a-divider>
              <div v-for="(a,index) in agencyList" :key="a">
                <a-divider style="margin: 0;" v-if="index != 0"></a-divider>
                <a-col :span="8">
                  <a-radio :value="a.id">{{ownerName}}</a-radio>
                </a-col>
                <a-col :span="8">{{mansionName}}</a-col>
                <a-col :span="8">{{a.startDate}} - {{a.endDate}}</a-col>
              </div>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </div>
    </a-row>
  </div>
</template>

<script>
  export default {
    name: 'agencySelector',
    props: {
      defaultValue:{
        type:String,
        default: null,
      },
      agencyList:{
        type: Array,
        default: []
      },
      ownerName:{
        type:String,
        default:null
      },
      disabled:{
        type:Boolean,
        default : false,
      },
      mansionName:{
        type:String,
        default:null,
      },
    },
    data() {
      return {
        dealConfirmForm: this.$form.createForm(this),
        decorators:{
          agencyId:['agencyId',{}],
        }
      }
    },
    mounted() {
      console.log('asdasd', this.mansionName)

    },
    methods: {
      setDefaultValue(agencyId){
        this.dealConfirmForm.setFieldsValue({
          agencyId: agencyId
        })
      },
      getAgencyId(){
        return this.dealConfirmForm.getFieldsValue()
      },
      hideAgency(){
        if(!this.disabled){
          this.$emit('hideAgency')
        }
      },
      openAddAgencyModal(){
        if(!this.disabled){
          this.$emit('openAddAgencyModal')
        }
      },
      setAgency(id){
        this.dealConfirmForm.setFieldsValue({agencyId: id})
      }
    }
  }
</script>

<style scoped lang="less">
  #agencySelector{
    .select_list{
      padding: 0 20px;
    }
  }
</style>